module.exports = __webpack_public_path__ + "media/images/icons/location-474e2004318df98a84d6e5399e72dc84.svg";